/* eslint-disable no-unused-vars */
import { useState } from 'react';
import classNames from 'classnames';
import Swal from 'sweetalert2';
import loadingGif from '../../assets/Other/loading.gif';
import { toast } from 'react-toastify';
import request from '../../utils/APIHelper/request';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import moment from 'moment';

/* eslint-disable no-unused-vars */
const SetPasswordAndCreateUser = ({ data, swalModal }) => {
  const [updateLoading, setUpdateLoading] = useState();
  const [password, setPassword] = useState('');

  const createUser = async () => {
    const transformedBirthay = parseInt(
      moment(data?.birthday).format('YYYYMMDD'),
    );
    const tranformedData = { ...data, birthday: transformedBirthay };

    if (password.length > 0) {
      const result = await request({
        url: `${controllers.user}createUser`,
        type: requestTypes.post,
        params: { password },
        body: tranformedData,
        setLoading: setUpdateLoading,
        disableLogOut: true,
      });
      if (result?.code === responseTypes.success) {
        toast.success(result?.message || 'Success!');
        window.location.reload();
        Swal.close();
      } else {
        toast.error(
          result?.message || 'Something went wrong while creating a user!',
        );
      }
    }
  };
  return (
    <div className="flex flex-col h-full justify-between px-10">
      <div className="flex-grow flex items-center justify-center">
        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border-b border-blue-800 focus:border-blue-400 text-blue-900 focus:outline-none my-10 min-w-[300px]"
          type="password"
          placeholder="Password..."
        />
      </div>
      <div className="p-4 flex justify-between">
        {updateLoading ? (
          <img
            className="w-5 h-5 mx-auto float-left my-2 ml-3"
            src={loadingGif}
          />
        ) : (
          <div
            onClick={createUser}
            className={classNames(
              'bg-blue-900 text-white inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer hover:bg-blue-800 hover:transition-all hover:duration-300',
              password.length <= 0 && '!bg-gray-500',
            )}
          >
            Set password
          </div>
        )}
        <div
          onClick={() => Swal.close()}
          className={classNames(
            'bg-gray-300 text-gray-700 inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer hover:bg-gray-400 hover:transition-all hover:duration-300',
          )}
        >
          Close
        </div>
      </div>
    </div>
  );
};

export default SetPasswordAndCreateUser;
